import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout';
import strings from "../../components/Language";
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import DCABot from "./ListItems/DCABot";
import BOLLBot from "./ListItems/BOLLBot";
import AIBot from "./ListItems/AIBot";
import "./quatitative.scss";
import LoaderContext from '../../components/Loader/LoaderContext.js';
import SwipeableViews from 'react-swipeable-views';

class QuatitativeScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		
		let savedTabValue = sessionStorage.getItem('quantitativeTabValue');
		let initialTab = savedTabValue !== null ? parseInt(savedTabValue) : 0;
		
		this.state = {
			access_token: "",
			tabValue: initialTab,
			is_dca_logs: initialTab === 0,
			is_boll_logs: initialTab === 1,
			is_ai_logs: initialTab === 2,
			balance: 0,
			TabItems: ['DCA', 'CTS', 'AI'],
		}
		this.handleChange = this.handleChange.bind(this);

	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		var self = this;
		setLoading(true);
		if (self.state.access_token) {

			axios({
				method: 'GET',
				url: api.balance,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage()
				}
			}).then(function (ress) {
				if (ress.data && ress.data.error === 200) {
					self.setState({ balance: (ress.data && ress.data.data && ress.data.data.balance) ? ress.data.data.balance : 0 });
				}
				setLoading(false);
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};

	handleChange(event, newValue) {
		const self = this;
		sessionStorage.setItem('quantitativeTabValue', newValue);
		if (newValue === 0 || newValue === "DCABot") {
			self.setState({
				is_dca_logs: true,
				is_boll_logs: false,
				is_ai_logs: false,
			})
		} else if (newValue === 2 || newValue === "AIBot") {
			self.setState({
				is_dca_logs: false,
				is_boll_logs: false,
				is_ai_logs: true,
			})
		} else {
			self.setState({
				is_dca_logs: false,
				is_boll_logs: true,
				is_ai_logs: false,
			})
		}
		self.setState({ tabValue: newValue });
	};

	render() {

		return (
			<>
				<Layout data={{ "title": strings.Quantitative, is_dca_logs: this.state.is_dca_logs, is_boll_logs: this.state.is_boll_logs }}>

					<div className="" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
						<Tabs
							value={this.state.tabValue}
							onChange={this.handleChange}
							variant="scrollable"
							scrollButtons="auto"
							aria-label=""
						>
							<Tab label="DCA" />
							<Tab label="CTS" />
							<Tab label="AI" />
						</Tabs>

						<div style={{ marginRight: 15 }} className="flex-center">
							<Link to={{ pathname: `/orders/${this.state.TabItems[this.state.tabValue]}` }} style={{ top: 5, fontSize: 16 }}>{strings.logs}</Link>
						</div>
					</div>
					<SwipeableViews index={this.state.tabValue} onChangeIndex={(index) => this.handleChange(null, index)} style={{ minHeight: "calc(50vh - 190px)", paddingBottom: 50 }}>
						<div role="tabpanel" hidden={this.state.tabValue !== 0}>
							{this.state.tabValue === 0 ?
								<div className="">
									<DCABot />
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 1}>
							{this.state.tabValue === 1 ?
								<div className="">
									<BOLLBot />
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 2}>
							{this.state.tabValue === 2 ?
								<div className="">
									<AIBot />
								</div>
								: null}
						</div>
					</SwipeableViews>

					<div className="" style={{ position: "fixed", zIndex: 9999999999, bottom: 70, width: "100%", backgroundColor: "#000", padding: 10 }}>
						<div className="" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
							<div style={{ marginRight: 10, borderWidth: 1, borderStyle: "solid", borderRadius: 10, borderColor: "#FFF", paddingInline: 15 }}>
								<div style={{ fontSize: 14 }}>{strings.usdt_balance}: {Number.parseFloat(this.state.balance).toFixed(2)}</div>
							</div>
						</div>
					</div>
				</Layout>
			</>
		);
	}
}

export default QuatitativeScreen;